import React from 'react';

type Props = {
  visible: boolean;
  saving?: boolean;
  applying?: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onApply?: () => void;
};

export default function SettingsStickyBar({
  visible,
  saving = false,
  applying = false,
  onSave,
  onDiscard,
  onApply,
}: Props) {
  if (!visible) return null;

  return (
    <div className="settings-sticky-bar" role="region" aria-label="Unsaved changes">
      <div className="settings-sticky-bar__inner">
        <p className="settings-sticky-bar__message">
          <span className="settings-sticky-bar__dot" aria-hidden="true" />
          Unsaved changes
        </p>
        <div className="settings-sticky-bar__actions">
          <button type="button" className="btn btn-ghost" onClick={onDiscard} disabled={saving || applying}>
            Discard
          </button>
          {onApply && (
            <button type="button" className="btn" onClick={onApply} disabled={saving || applying}>
              {applying ? 'Applying…' : 'Apply to app'}
            </button>
          )}
          <button type="button" className="btn btn-primary" onClick={onSave} disabled={saving || applying}>
            {saving ? 'Saving…' : 'Save changes'}
          </button>
        </div>
      </div>
    </div>
  );
}
